import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 text-xs font-medium text-primary-400 mb-3">
            <i className="ri-information-line"></i>
            品牌故事
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于我们</h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed text-center mb-10">
            {aboutData.content}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutData.highlights.map((item, idx) => (
              <div
                key={idx}
                className="p-5 rounded-2xl bg-background-50 border border-background-200/60 text-center"
              >
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400 mb-1">{item.value}</div>
                <div className="text-xs text-foreground-500">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}